module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix home"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('v-container', {
    staticClass: "sponsor-info"
  }, [_c('app-logo'), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "mt-5": "",
      "xs12": "",
      "sm12": "",
      "md12": "",
      "offset-lg4": "",
      "lg4": ""
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))])])], 1), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../src/assets/fish1.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../src/assets/fish-2.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../src/assets/fish-3.png")
    }
  })])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seaweed-right"
  }, [_c('img', {
    staticClass: "right-seaweed",
    attrs: {
      "src": require("../assets/seaweed-right.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seaweed-left"
  }, [_c('img', {
    staticClass: "left-seaweed",
    attrs: {
      "src": require("../assets/seaweed-left.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0376b3dd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sponsors-Info.vue
// module id = 76
// module chunks = 1